import { t, defineMessage } from '@lingui/macro';
import { i18n } from '@lingui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import Icon from '@material-ui/core/Icon';
import classnames from 'classnames';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { onChangeMapFilters } from '../../../ac/onChangeMapFilters';
import { StandardRadioGroup } from '../StandardRadioGroup';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendRenderer } from '../../LegendRenderer/LegendRenderer';
import { ROUTE_ANOMALIES_H3_LEGEND, ROUTE_ANOMALIES_H3_CNT_LEGEND } from '../../../constants/legends';
import styles from '../FilterSidebar.module.css';
// DA-14308: Фильтр слоя «Гео вылеты»
const H3_ZOOMS = [ 6, 7, 8, 9, 10, 11, 12, 'auto' ];
const DIRECTION_OPTIONS = [
    { value: 'from', label: defineMessage({ message: 'откуда (реальная позиция)' }) },
    { value: 'to',   label: defineMessage({ message: 'куда (аномальная позиция)' }) },
];
const PERIOD_OPTIONS = [
    { value: '1d',  label: defineMessage({ message: '1 день' }) },
    { value: '7d',  label: defineMessage({ message: '7 дней' }) },
    { value: '30d', label: defineMessage({ message: '30 дней' }) },
    { value: 'all', label: defineMessage({ message: 'Весь период' }) },
];
const SRC_OPTIONS = [
    { value: 'all', label: defineMessage({ message: 'ALL (все источники)' }) },
    { value: 'gps', label: 'GPS' },
    { value: 'lbs', label: 'LBS' },
    { value: 'phone_gps', label: 'PHONE_GPS' },
    { value: 'ble_s', label: 'BLE_S' },
];
const METRIC_OPTIONS = [
    { value: 'median_dist', label: defineMessage({ message: 'Медиана дистанции (м)' }) },
    { value: 'cnt', label: defineMessage({ message: 'Количество выбросов' }) },
    { value: 'bin', label: defineMessage({ message: 'Бин дистанции' }) },
];
const BIN_OPTIONS = [
    { value: 'lt_10', label: defineMessage({ message: '< 10 м' }) },
    { value: 'd_10_25', label: defineMessage({ message: '10–25 м' }) },
    { value: 'd_25_50', label: defineMessage({ message: '25–50 м' }) },
    { value: 'd_50_100', label: defineMessage({ message: '50–100 м' }) },
    { value: 'd_100_250', label: defineMessage({ message: '100–250 м' }) },
    { value: 'd_250_500', label: defineMessage({ message: '250–500 м' }) },
    { value: 'd_500_1000', label: defineMessage({ message: '500–1000 м' }) },
    { value: 'd_1000_2500', label: defineMessage({ message: '1–2.5 км' }) },
    { value: 'gt_2500', label: defineMessage({ message: '> 2.5 км' }) },
];
const RouteAnomaliesH3FilterComponent = ({
    onChangeMapFilters,
    routeAnomaliesH3Zoom,
    routeAnomaliesPeriod,
    routeAnomaliesSrc,
    routeAnomaliesMetric,
    routeAnomaliesBin,
    routeAnomaliesWeighted,
    routeAnomaliesDirection,
}) => {
    const [ isH3ZoomExpanded, setIsH3ZoomExpanded ] = useState(false);
    const handlePeriodChange = ({ target: { value } }) => onChangeMapFilters('routeAnomaliesPeriod', value);
    const handleSrcChange = ({ target: { value } }) => onChangeMapFilters('routeAnomaliesSrc', value);
    const handleMetricChange = ({ target: { value } }) => onChangeMapFilters('routeAnomaliesMetric', value);
    const handleBinChange = ({ target: { value } }) => onChangeMapFilters('routeAnomaliesBin', value);
    const handleWeightedChange = () => onChangeMapFilters('routeAnomaliesWeighted', !routeAnomaliesWeighted);
    const handleH3ZoomChange = ({ target: { value } }) => onChangeMapFilters('routeAnomaliesH3Zoom', value);
    const handleDirectionChange = ({ target: { value } }) => onChangeMapFilters('routeAnomaliesDirection', value);
    const toggleH3Zoom = () => setIsH3ZoomExpanded(!isH3ZoomExpanded);
    return (
        <div>
            <div className={styles.legHead}>{t`Режим`}:</div>
            <StandardRadioGroup
                value={routeAnomaliesDirection}
                onChange={handleDirectionChange}
            >
                {DIRECTION_OPTIONS.map(({ value, label }) => (
                    <FormControlLabel
                        key={value}
                        className={styles.isochroneFilterLabel}
                        control={
                            <Radio
                                checked={routeAnomaliesDirection === value}
                                onChange={handleDirectionChange}
                                value={value}
                                className={classnames(styles.isochroneFilterInput, {
                                    [styles.checkedIsochroneFilterInput]: routeAnomaliesDirection === value,
                                })}
                                size="small"
                            />
                        }
                        label={i18n._(label)}
                        labelPlacement="end"
                    />
                ))}
            </StandardRadioGroup>
            <div className={styles.legHead}>{t`Период`}:</div>
            <StandardRadioGroup
                value={routeAnomaliesPeriod}
                onChange={handlePeriodChange}
            >
                {PERIOD_OPTIONS.map(({ value, label }) => (
                    <FormControlLabel
                        key={value}
                        className={styles.isochroneFilterLabel}
                        control={
                            <Radio
                                checked={routeAnomaliesPeriod === value}
                                onChange={handlePeriodChange}
                                value={value}
                                className={classnames(styles.isochroneFilterInput, {
                                    [styles.checkedIsochroneFilterInput]: routeAnomaliesPeriod === value,
                                })}
                                size="small"
                            />
                        }
                        label={i18n._(label)}
                        labelPlacement="end"
                    />
                ))}
            </StandardRadioGroup>
            <div className={styles.legHead}>{t`Источник (src)`}:</div>
            <StandardRadioGroup
                value={routeAnomaliesSrc}
                onChange={handleSrcChange}
            >
                {SRC_OPTIONS.map(({ value, label }) => (
                    <FormControlLabel
                        key={value}
                        className={styles.isochroneFilterLabel}
                        control={
                            <Radio
                                checked={routeAnomaliesSrc === value}
                                onChange={handleSrcChange}
                                value={value}
                                className={classnames(styles.isochroneFilterInput, {
                                    [styles.checkedIsochroneFilterInput]: routeAnomaliesSrc === value,
                                })}
                                size="small"
                            />
                        }
                        label={typeof label === 'string' ? label : i18n._(label)}
                        labelPlacement="end"
                    />
                ))}
            </StandardRadioGroup>
            <div className={styles.legHead}>{t`Метрика`}:</div>
            <StandardRadioGroup
                value={routeAnomaliesMetric}
                onChange={handleMetricChange}
            >
                {METRIC_OPTIONS.map(({ value, label }) => (
                    <FormControlLabel
                        key={value}
                        className={styles.isochroneFilterLabel}
                        control={
                            <Radio
                                checked={routeAnomaliesMetric === value}
                                onChange={handleMetricChange}
                                value={value}
                                className={classnames(styles.isochroneFilterInput, {
                                    [styles.checkedIsochroneFilterInput]: routeAnomaliesMetric === value,
                                })}
                                size="small"
                            />
                        }
                        label={i18n._(label)}
                        labelPlacement="end"
                    />
                ))}
            </StandardRadioGroup>
            {routeAnomaliesMetric === 'bin' && (
                <>
                    <div className={styles.legHead}>{t`Бин дистанции`}:</div>
                    <StandardRadioGroup
                        value={routeAnomaliesBin}
                        onChange={handleBinChange}
                    >
                        {BIN_OPTIONS.map(({ value, label }) => (
                            <FormControlLabel
                                key={value}
                                className={styles.isochroneFilterLabel}
                                control={
                                    <Radio
                                        checked={routeAnomaliesBin === value}
                                        onChange={handleBinChange}
                                        value={value}
                                        className={classnames(styles.isochroneFilterInput, {
                                            [styles.checkedIsochroneFilterInput]: routeAnomaliesBin === value,
                                        })}
                                        size="small"
                                    />
                                }
                                label={i18n._(label)}
                                labelPlacement="end"
                            />
                        ))}
                    </StandardRadioGroup>
                    <div style={{ display: 'flex', alignItems: 'center', padding: '4px 10px' }}>
                        <span>{t`Взвешенные значения (доля, 0–1)`}</span>
                        <label className={styles.switch}>
                            <input
                                type='checkbox'
                                checked={routeAnomaliesWeighted}
                                onChange={handleWeightedChange}
                            />
                            <span className={classnames(styles.sliderRound, styles.slider)} />
                        </label>
                    </div>
                </>
            )}
            <div
                className={classnames(styles.legHead, {
                    [styles.expandableLegHead]: true,
                    [styles.expandableLegHeadOpen]: isH3ZoomExpanded,
                })}
                onClick={toggleH3Zoom}
                style={{ cursor: 'pointer', userSelect: 'none', display: 'inline-flex', alignItems: 'center' }}
            >
                {t`H3 Zoom`}:
                <Icon style={{ marginLeft: 'auto', transition: 'transform 0.25s ease' }}>expand_more</Icon>
            </div>
            {isH3ZoomExpanded && (
                <StandardRadioGroup
                    value={String(routeAnomaliesH3Zoom)}
                    onChange={handleH3ZoomChange}
                >
                    {H3_ZOOMS.map(zoom => (
                        <FormControlLabel
                            key={zoom}
                            className={styles.isochroneFilterLabel}
                            control={
                                <Radio
                                    checked={String(routeAnomaliesH3Zoom) === String(zoom)}
                                    onChange={handleH3ZoomChange}
                                    value={String(zoom)}
                                    className={classnames(styles.isochroneFilterInput, {
                                        [styles.checkedIsochroneFilterInput]: String(routeAnomaliesH3Zoom) === String(zoom),
                                    })}
                                    size="small"
                                />
                            }
                            label={zoom}
                        />
                    ))}
                </StandardRadioGroup>
            )}
            <LegendRenderer config={routeAnomaliesMetric === 'cnt' ? ROUTE_ANOMALIES_H3_CNT_LEGEND : ROUTE_ANOMALIES_H3_LEGEND} />
        </div>
    );
};
const mapStateToProps = ({ mapFilters: {
    routeAnomaliesH3Zoom,
    routeAnomaliesPeriod,
    routeAnomaliesSrc,
    routeAnomaliesMetric,
    routeAnomaliesBin,
    routeAnomaliesWeighted,
    routeAnomaliesDirection,
} }) => ({
    routeAnomaliesH3Zoom,
    routeAnomaliesPeriod,
    routeAnomaliesSrc,
    routeAnomaliesMetric,
    routeAnomaliesBin,
    routeAnomaliesWeighted,
    routeAnomaliesDirection,
});
const ConnectedComponent = connect(mapStateToProps, { onChangeMapFilters })(RouteAnomaliesH3FilterComponent);
export const RouteAnomaliesH3Filter = withDisplayedLayersCheck(
    ConnectedComponent,
    t`Гео вылеты`
);


